var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStormBrightGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stormBright"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#413d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7080e0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormBrightGradient);
export default __webpack_public_path__ + "static/media/stormBrightGradient.855290d2a6f23b3dcc358c6bb6b165e1.svg";
export { ForwardRef as ReactComponent };